export default __webpack_public_path__ + "sam.08039a15a66e764d9b90.png";